import gql from "graphql-tag";

export const MAILING_LISTS_QUERY = gql`
  query GetMailingListsQuery {
    mailingLists {
      id
      description
      address
      subscribedMembers
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/MailingListsQuery/queries.ts